import { Component } from 'react';
import classNames from 'classnames/bind';
import { Dropdown } from 'react-bootstrap';
import autoBind from 'react-autobind';

import Styles from '../story-filters-styles.module.scss';
import FilterButtonInfo from '../StoryFiltersButton/FilterButtonInfo';
import withComponentName from '../../../decorators/withComponentName';
import SliderComponent from './SliderComponent';

import StorageSvc from '../../../services/StorageSvc';

const cx = classNames.bind(Styles);

export class ScoreFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      dropdown: {
        open: false,
      },
      stateChangedFromFilter: false, // to determine if state value changed from filter or outside
    };
    this.forceOpen = false;
    autoBind(this);
  }

  componentDidMount() {
    const { savedFilterValue, defaultSelected } = this.props;
    const presisted = StorageSvc.getItem('ScoreFilter');

    if (presisted !== null && !savedFilterValue) {
      const rehydrate = JSON.parse(presisted);
      this.setState(rehydrate);
    } else {
      this.setState({ value: savedFilterValue || defaultSelected });
    }
  }

  componentDidUpdate(prevProps) {
    const { defaultSelected } = this.props;
    const { stateChangedFromFilter } = this.state;

    // only fire this when score value changed from another component
    if (defaultSelected !== prevProps.defaultSelected && !stateChangedFromFilter) {
      this.setState({ value: defaultSelected });
    }
  }

  componentWillUnmount() {
    const { token } = this.props;
    if (!token) this.saveState();
  }

  onUpdate(value) {
    this.setState({
      value: value[0],
    });
  }

  onChange(value) {
    const {
      piwikEnabled, freezeStories, action, token,
    } = this.props;

    freezeStories(false);

    this.setState({
      value: value[0],
      stateChangedFromFilter: true,
    }, () => {
      // save to localstorage for guest user
      if (!token) this.saveState();

      setTimeout(() => {
        this.setState({ stateChangedFromFilter: false });
      }, 500);
    });

    action(value[0], token);
    if (piwikEnabled) _paq.push(['trackEvent', 'Filters', 'Minimum CF score', value[0]]);
  }

  toggleDropdown(status) {
    const { freezeStories } = this.props;
    const { dropdown } = this.state;

    if (this.forceOpen) {
      this.forceOpen = false;
      return;
    }

    this.setState({
      dropdown: {
        ...dropdown,
        open: status,
      },
    }, () => {
      freezeStories(status);
    });
  }

  saveState() {
    const { value } = this.state;
    StorageSvc.setItem('ScoreFilter', JSON.stringify({ value }));
  }

  render() {
    const {
      rbi,
      isSearch,
      width,
      dropdownTitle,
      hasBigScreenDesign,
    } = this.props;
    const { dropdown, value } = this.state;

    return (
      <div className={`${cx('score-filter', { 'search-disabled': isSearch, big_screen: hasBigScreenDesign })} score-filter`}>
        {width >= 1025 ? (
          <Dropdown
            className={cx('story-filters_btn', { rbi, 'is-search search-disabled': isSearch })}
            open={dropdown.open}
            id={Styles['score-dropdown']}
            onToggle={(status, event, source) => this.toggleDropdown(status, event, source)}
          >
            <span className="score-popover">
              Results sorted by search relevance. This filter is ignored.
            </span>
            <Dropdown.Toggle variant="default" className={cx({ 'is-search search-disabled': isSearch })}>
              <FilterButtonInfo
                dropdownTitle={dropdownTitle}
                openFilter={dropdown.open}
                rbi={rbi}
                width={width}
                selectedValue={(
                  <>
                    &gt;=
                    {value}
                    %
                  </>
                )}
                buttonErr={dropdown.selected === 0}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu
              rootCloseEvent="click"
              show={dropdown.open}
              flip={false}
              bsPrefix="dropdown-menu"
            >
              <span className={cx('dropdown_title')}>
                {dropdownTitle}
                :
              </span>
              <div className={Styles.dropdown_range}>
                <span className={Styles.dropdown_range__low}>1%</span>
                <span className={Styles.dropdown_range__high}>100%</span>
              </div>
              <SliderComponent
                rbi={rbi}
                value={value}
                onUpdate={this.onUpdate}
                onChange={this.onChange}
                hasBigScreenDesign={hasBigScreenDesign}
              />
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <div className={cx('score-filter__container', { rbi })}>
            <span className={cx({ 'search-disabled': isSearch })}>Score</span>
            <div className={cx('score-filter__slider-container', { 'search-disabled': isSearch })}>
              <SliderComponent
                rbi={rbi}
                value={value}
                onUpdate={this.onUpdate}
                onChange={this.onChange}
                hasBigScreenDesign={hasBigScreenDesign}
              />
              <div>
                {value}
                %
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withComponentName(ScoreFilter);
